import type { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { PaymentStatus } from 'shared/api/kyrgyzstan/orders'
import { Button } from 'shared/ui/button'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface CancelBookingActionProps {
  onCancel: () => void | Promise<void>
  isLoading?: boolean
  isCheckinWithin24h?: boolean
  paymentStatus?: PaymentStatus
}

const getWarningKey = (
  isCheckinWithin24h: boolean,
  paymentStatus: PaymentStatus,
): string => {
  const base = 'kyrgyzstan_block.cancel_booking.'
  if (paymentStatus === 'full') {
    return isCheckinWithin24h
      ? `${base}full_final_warning`
      : `${base}full_refund_warning`
  }
  return isCheckinWithin24h ? `${base}final_warning` : `${base}refund_warning`
}

export const CancelBookingAction: FC<CancelBookingActionProps> = ({
  onCancel,
  isLoading = false,
  isCheckinWithin24h = false,
  paymentStatus = 'full',
}) => {
  const { t } = useTranslation()
  const warningKey = getWarningKey(isCheckinWithin24h, paymentStatus)

  return (
    <Paper
      padding={[12, 16, 28]}
      className={s.buttonContainer}
    >
      <p className={clsx('semi-bold-14', s.buttonDescription)}>
        {t(warningKey)}
      </p>

      <Button
        variant="danger"
        onClick={onCancel}
        disabled={isLoading}
      >
        <span className="semi-bold-17">
          {isLoading
            ? t('loading')
            : t('kyrgyzstan_block.cancel_booking.cancel_button')}
        </span>
      </Button>
    </Paper>
  )
}
